const SIZES = {
  NAME: 55,
  UPDATED: 29,
  STATUS: 16,
};

export default SIZES;
